import React, {Component} from 'react'
import ReactDOM from 'react-dom';
//import Slider from '@material-ui/core/Slider'
import Cropper from 'react-easy-crop'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'

class UploadFileField extends Component {
  constructor(){
    super();

    this.state = {
      src:null,
      crop: {
        x: 0,
        y: 0
      },
      zoom: 1,
      aspect: 1 / 0.72,
      croppedImage:false,
      croppedAreaPixels:{},
      modal:false,
      size: 'lg'
    }
  }


  onFileChange(e, field) {
    let value = e.target.files[0];
    if(value){
      this.setState({modal:true})
    }
    //crop data
    const reader = new FileReader();
    reader.addEventListener('load', () =>
      this.setState({ src: reader.result })
    );
    reader.readAsDataURL(value);
    //end crop data

    if (value && value.size > 4194304) {
      alert('Maximum image size is 4MB.');
      e.target.value = null;
      return;
    }

    this.props.validate(value, field);
    this.props.onSelectedImage(true);
    this.toggleModal();
  }

  //crop functions
  onCropChange(crop){
    this.setState({ crop:crop })
  }

  onCropComplete(croppedArea, croppedAreaPixels){
    this.setState({croppedAreaPixels:croppedAreaPixels});
  }

  onZoomChange(zoom){
    this.setState({ zoom:zoom })
  }

  drawImage(){
    const croppedAreaPixels = this.state.croppedAreaPixels;
    this.ctx.drawImage(this.image, croppedAreaPixels.x, croppedAreaPixels.y, croppedAreaPixels.width, croppedAreaPixels.height, 0, 0, croppedAreaPixels.width, croppedAreaPixels.height);

    //make file from canvas
    const canvas = document.getElementById("croppedImage");
    // convert to Blob
    canvas.toBlob( (blob) => {
      const file = new File( [ blob ], "newImage.png" );
      const dT = new DataTransfer();
      dT.items.add(file);
      this.props.croppedImage(file);
    } );
    this.toggleModal();
  }

  toggleModal(){
    this.setState({modal: !this.state.modal});
    this.setState({src: null});
  }
  //end crop functions

  render() {
    let field = this.props.field;


    let hasErrors = field.errors.length > 0 ? true : false

    const { src, croppedAreaPixels, crop, zoom, aspect } = this.state;

    return (
      <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>

      <div style={{display:"none"}}>
        <img
          ref={imageRef => this.image = imageRef}
          id="source"
          style={{display:"none"}}
          src={src} />
        <canvas
          ref={canvas => {
            this.canvas = canvas;
            canvas && (this.ctx = canvas.getContext('2d'))
          }}
          width={croppedAreaPixels.width}
          height={croppedAreaPixels.height}
          id="croppedImage"
        />
      </div>

        <label className="form-control-label">{field.rules.title}</label>
        <div className="input-group">
          <input type="file" name={field.lname} accept=".jpg,.jpeg,.png,.gif" onChange={e => this.onFileChange(e, field)} />
        </div>

         <Modal
           isOpen={this.state.modal}
           toggle={this.toggleModal}
           wrapClassName={this.state.className}
           size={this.state.size}
           >
           <ModalHeader>
           </ModalHeader>
           <ModalBody>
           {this.state.src &&
             <>
             <div style={{position:"relative"}}>
               <div style={{position:"static",width:"500px", height:"500px"}}>
                 <Cropper
                   image={this.state.src}
                   crop={this.state.crop}
                   zoom={this.state.zoom}
                   aspect={this.state.aspect}
                   onCropChange={this.onCropChange.bind(this)}
                   onCropComplete={this.onCropComplete.bind(this)}
                   onZoomChange={this.onZoomChange.bind(this)}
                   showGrid={true}
                 />
                </div>
              </div>
              </>
            }
           </ModalBody>
           <ModalFooter>
             <button className="btn btn-primary btn-rounded mr-3" onClick={this.drawImage.bind(this)}>
               Crop
             </button>

              <button className="btn btn-primary btn-rounded" onClick={this.toggleModal.bind(this)}>
               Close
              </button>
           </ModalFooter>
           </Modal>


        {field.errors.map((error, i) => (
          <div key={i} className="form-text text-danger">
            {error}
          </div>
        ))}

      </div>
    )
  }
}

export default (UploadFileField)
